export const ValuePitch = () => (
	<div className="text-center max-w-3xl mx-auto mb-16">
		<h1 className="text-4xl font-bold mb-6 pb-1 bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
			Transform Your Ideas into Reality at Lightning Speed
		</h1>
		<p className="text-lg text-gray-300 mb-8">
			Experience the future of MVP development with our AI-powered platform. We turn your vision into a working product in record time, 
			without compromising on quality or scalability. Whether you're a startup founder, entrepreneur, or enterprise innovator, 
			we have the perfect solution for your needs.
		</p>
		<div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
			<div className="card">
				<div className="text-3xl mb-2">🚀</div>
				<h3 className="font-semibold mb-2">Lightning Fast</h3>
				<p className="text-sm text-gray-400">From concept to deployment in as little as 24 hours</p>
			</div>
			<div className="card">
				<div className="text-3xl mb-2">🤖</div>
				<h3 className="font-semibold mb-2">AI-Powered</h3>
				<p className="text-sm text-gray-400">Cutting-edge AI technology for smarter development</p>
			</div>
			<div className="card">
				<div className="text-3xl mb-2">💎</div>
				<h3 className="font-semibold mb-2">Enterprise-Ready</h3>
				<p className="text-sm text-gray-400">Scalable, secure, and built for growth</p>
			</div>
		</div>
	</div>
);
